import { triggerBrowserDownload } from '@helpers/jobLinkHelpers';
import type { AsrTranscript } from '../api/types';

export const downloadTranscriptJson = (transcript: AsrTranscript): void => {
  const blob = new Blob([JSON.stringify(transcript, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  try {
    triggerBrowserDownload(url, 'asr.json');
  } finally {
    URL.revokeObjectURL(url);
  }
};
